import { Component, Input, EventEmitter, Output } from '@angular/core';
import {
    PlatformService, LoggingService, TokenService, LocalStorageService, NotificationsService,
    PriceService, AccountService, TeamEvent, InstituteSearchResult, SiteLayout
} from '@varsity/services';
import { BaseComponent } from '@varsity/components';
import { PopoverController, ToastController, CardContent } from 'ionic-angular';
import { Observable, ReplaySubject } from 'rxjs';
import { InAppBrowser } from '@ionic-native/in-app-browser';
/**
 * Generated class for the AccordionListComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
    selector: 'accordion-list',
    templateUrl: 'accordion-list.html'
})
export class AccordionListComponent extends BaseComponent {
    //@Input() public sponsorsInfo: Observable<InstituteSearchResult[]>;
    //eventsGroupedObservable = new ReplaySubject<{ sponsorID: number, events: TeamEvent[], sitelayout: SiteLayout; }[]>(1);
    @Input('groupedEvents') sponsorEvents: { sponsorID: number, events: TeamEvent[], sitelayout: SiteLayout, isDisplayed: boolean; };
    @Output() public eventSelectHandler: EventEmitter<any> = new EventEmitter();
    sportsString: string[] = [];


    

    constructor(
        protected platformService: PlatformService,
        protected loggingService: LoggingService,
        protected tokenService: TokenService,
        protected localStorageService: LocalStorageService,
        protected notificationsService: NotificationsService,
        protected priceService: PriceService,
        protected popoverCtrl: PopoverController,
        protected toastCtrl: ToastController,
        protected accountService: AccountService,
        protected iab: InAppBrowser,
    ) {
        super(
            loggingService, tokenService, localStorageService,
            notificationsService, platformService, toastCtrl, popoverCtrl, iab,
            "AccordionListComponent"
        );
        
    }

    ngOnInit() {
        super.ngOnInit();
        this.loggingService.debug("Accordion EVENTS ==> ", this.sponsorEvents);
        this.setupSportsString(this.sponsorEvents.events);

    }

    selectEventWrapper(teamEvent?: TeamEvent): void {
        console.debug("DEBUG EVENT", teamEvent);
        this.eventSelectHandler.emit(teamEvent);
    }

    toggleCardContent(): void {
        this.sponsorEvents.isDisplayed = !this.sponsorEvents.isDisplayed;     
    }

    setupSportsString(events: TeamEvent[]): void {
        //var displayedString = "";
        for (let sponsorEvent of events) {
            if (sponsorEvent.Sport) {
                if (this.sportsString.length == 0) {
                    this.sportsString.push(sponsorEvent.Sport);
                } else {
                    if (!(this.sportsString.indexOf(sponsorEvent.Sport) >= 0)) {
                        this.sportsString.push(sponsorEvent.Sport);
                    } 
                }
            } 
        }
    }

}



// WEBPACK FOOTER //
// ./src/components/accordion-list/accordion-list.ts